export default __webpack_public_path__ + "static/media/backWhite.2c6c44fa.svg";